<div class="d-flex align-items-center parent-side-nav" [ngClass]="{'selected': selectedItem?.displayName === item.displayName }">
  <div class="d-flex align-items-center flex-grow-1" (click)="toggleExpand()" (keydown)="toggleExpand()">
    <!-- Circle with index number -->
    <!-- <div class="circle-number d-flex align-items-center justify-content-center fw-semibold text-white"></div> -->
    
    <!-- Item Name -->
    <span class="nav-item-font ms-2 py-2">{{ item.displayName }}</span>
    
    <!-- Expand/Collapse Icon for Items with Children -->
    <span *ngIf="item.children && item.children.length > 0" class="ms-auto">
      <i [ngClass]="expandedItems.has(item.id) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
    </span>
  </div>

  <img *ngIf="item.enableMenu" class="menu-items" [matMenuTriggerFor]="menu" src="assets/images/menu-dots.png" alt="icon"/>

  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="onMenuClick('refresh', item)"> Refresh </button>
    <button mat-menu-item (click)="onMenuClick('createTestSuite', item)"> Create new test suite </button>
    <button mat-menu-item (click)="onMenuClick('create_test_script', item)"> Create new test script </button>
    <button mat-menu-item (click)="onMenuClick('save_test_script', item)"> Save test scripts </button>
  </mat-menu>
</div>

<!-- Nested Child Items -->
<div *ngIf="expandedItems.has(item.id) && item.children && item.children.length > 0" class="ps-4">
  <ng-container *ngFor="let child of item.children | sortByKey: 'order': true; let k = index">
    <app-side-nav-item
      [item]="child"
      [index]="k + 1"
      [expandedItems]="expandedItems"
      (itemSelected)="onItemClick(child)"
      [selectedItem]="selectedItem"
    ></app-side-nav-item>
  </ng-container>
</div>
